// PhaseInfo Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import currency from '../../../../lib/currency.jsx'
import DateUtil from '../../../../lib/dateutil.jsx'
import IntlUtil from '../../../../lib/intlutil.jsx'
import Util from '../../../../lib/util.jsx'
import IconButton from '../../../common/icon_button/icon_button.jsx'
import InlineInput from '../../../common/inline_input/inline_input.jsx'

class PhaseInfo extends Component {
  static get propTypes () {
    return {
      onChange: PropTypes.func,
      onDrag: PropTypes.func,
      onToggleExpand: PropTypes.func,
      showExpand: PropTypes.bool,
      canEdit: PropTypes.bool,
      activeFilters: PropTypes.object,
      onClickStatus: PropTypes.func,
      onCopyPhase: PropTypes.func,
      onSave: PropTypes.func,
      onKeyDown: PropTypes.func,
      onDelete: PropTypes.func,
      onClickEdit: PropTypes.func,
      connectDragSource: PropTypes.func,
      phase: PropTypes.object,
      columnOptions: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      onChange: null,
      onDrag: null,
      onToggleExpand: null,
      showExpand: false,
      canEdit: false,
      activeFilters: null,
      onClickStatus: null,
      onCopyPhase: null,
      onSave: null,
      onKeyDown: null,
      onDelete: null,
      onClickEdit: null,
      connectDragSource: null,
      phase: null,
      columnOptions: []
    }
  }

  _renderCustomColumns () {
    const { phase, columnOptions, activeFilters } = this.props

    let totalBudget = 0
    let totalSpentAmount = 0
    let totalSellingPrice = 0
    const showTimeActivity =
      activeFilters.length === 0 || activeFilters.indexOf('time') >= 0
    const showExpenseActivity =
      activeFilters.length === 0 || activeFilters.indexOf('expense') >= 0

    if (phase.items) {
      phase.items.forEach(item => {
        if (
          (showTimeActivity && item.type === 'time-activity') ||
          (showExpenseActivity && item.type === 'expense-activity')
        ) {
          totalBudget += parseFloat(item.total)
          totalSpentAmount += parseFloat(item.spentAmount)
          totalSellingPrice +=
            item.sellingPrice === 0
              ? parseFloat(item.total)
              : parseFloat(item.sellingPrice)
        }
      })
    }

    const columnsValues = {
      budget: currency.formatSymbol(totalBudget),
      spent: currency.formatSymbol(totalSpentAmount),
      sales: currency.formatSymbol(totalSellingPrice)
    }

    const columnsEnabled = []
    if (columnOptions) {
      columnOptions.forEach(column => {
        if (!column.disabled && column.selected) {
          columnsEnabled.push(column.ident)
        }
      })
    }

    const noColumns = columnsEnabled.length
    return columnsEnabled.map((column, idx) => {
      return (
        <div className={`col ${noColumns}col ${column}`} key={idx}>
          {columnsValues[column]}
        </div>
      )
    })
  }

  render () {
    const {
      phase,
      showExpand,
      canEdit,
      onClickStatus,
      onCopyPhase,
      connectDragSource
    } = this.props

    return (
      <div className='phase-info'>
        <div className='col select'>
          <div className='col actionclose'>
            {showExpand && (
              <>
                {!phase.spentAmount && (
                  <IconButton
                    icon='x'
                    canHover
                    type='default'
                    size='small'
                    className='actionclose'
                    onClick={this._onDeletePhase.bind(this)}
                  />
                )}
                <IconButton
                  icon={phase.isExpand ? 'arrow-up' : 'arrow-down'}
                  className='actionexpand'
                  onClick={this._onToggleExpand} // eslint-disable-line react/jsx-handler-names
                />
              </>
            )}
          </div>
          <div className='col imagecont'>
            <IconButton
              icon='phase'
              size='big'
              hasBorder
              className={showExpand ? 'phaseicon' : 'phaseexpanded'}
            />
          </div>
        </div>
        <div className='col info'>
          <div className='title'>
            <InlineInput
              value={phase.title}
              showInput={phase.editable === 'title'}
              canEdit={canEdit}
              inputType='input'
              placeholder='project.viewBudget.phaseInputPlaceholder'
              onChange={this._onChangeInput.bind(this, 'title')}
              onBlur={this._onBlurInput.bind(this, 'title')}
              onKeyDown={this._onKeyDownInput.bind(this, 'title')}
              onClickEdit={this._onClickEditInput.bind(this, 'title')}
            />
          </div>
          <div className='attributes'>
            <div className='date'>
              {phase.fromDate && phase.toDate
                ? `${DateUtil.getDisplayDate(
                    phase.fromDate
                  )}-${DateUtil.getDisplayDate(phase.toDate)}`
                : ''}
              {phase.fromDate && !phase.toDate && (
                <div className='defaultdate'>
                  {`${DateUtil.getDisplayDate(phase.fromDate)} - `}
                  <span className='infinty'>&infin;</span>
                </div>
              )}
              {!phase.fromDate && phase.toDate && (
                <div className='defaultdate'>
                  <span className='infinty'>&infin; -</span>
                  {` ${DateUtil.getDisplayDate(phase.toDate)}`}
                </div>
              )}
            </div>
            <div className='status' onClick={onClickStatus}>
              <div className={`status status_${phase.status}`}>
                {IntlUtil.convertMessage(
                  Util.getTranslatedStatus(phase.status)
                )}
              </div>
            </div>
            {phase.overSpent > 0 && (
              <>
                <div className='status-label'>Phase Overspent</div>
                <div className='spent'>
                  {currency.formatSymbol(phase.overSpent)}
                </div>
              </>
            )}
            {phase.percentage > 0 && (
              <div
                className={`percentage${
                  phase.percentage > 100 ? ' haserror' : ''
                }`}
              >
                {phase.percentage + ' %'}
              </div>
            )}
          </div>
        </div>
        <div className='col hours' />
        <div className='col price' />
        {this._renderCustomColumns()}
        <div className='col actions'>
          <div className='col drag'>
            <IconButton
              icon='duplicate'
              type='secondary'
              className='actbutton'
              canHover
              onClick={onCopyPhase}
            />
            {connectDragSource(
              <div className='dragaction'>
                <IconButton icon='drag' iconSize='26' className='dragbutton' />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onChangeInput = (name, value, ev) => {
    const { phase, onChange } = this.props

    if (onChange) {
      onChange(phase.id, name, value, ev)
    }
  }

  _onBlurInput = (name, ev) => {
    const { phase, onSave } = this.props

    if (onSave) {
      onSave(phase.id, name, ev)
    }
  }

  _onKeyDownInput = (name, ev) => {
    const { phase, onKeyDown } = this.props

    if (onKeyDown) {
      onKeyDown(phase.id, name, ev)
    }
  }

  _onDeletePhase = () => {
    const { phase, onDelete } = this.props

    if (onDelete) {
      onDelete(phase.id, phase)
    }
  }

  _onToggleExpand = () => {
    const { phase, onToggleExpand } = this.props

    if (onToggleExpand) {
      onToggleExpand(phase.id)
    }
  }

  _onClickEditInput = name => {
    const { phase, onClickEdit } = this.props

    if (onClickEdit) {
      onClickEdit(phase.id, name)
    }
  }
}

export default PhaseInfo
